$(document).on('click', '.custom-product-options a', function(e) {
    
    e.preventDefault();
    let $el = $(this).parents('.shopify-section');
    $el.addClass('is-loadin');
    $(this).parents('ul').find('.is-current').removeClass('is-current');
    $(this).parent().addClass('is-current');

    let url = $(this).attr('href');
  
    $.ajax({
        url: url,
        method: 'GET',
        success: function(data) {
            let content = $(data).find('.megaProductWrapper').parent().html();
            let title = $(content).find('#seo_title').val();

            $('.megaProductWrapper').parent().html(content);
            $el.removeClass('is-loadin');
            let container = $('.product-section');
          
            setTimeout(function(){
              let p = new theme.Product(container[0]);
              console.log(p);
              console.log(p.variants.currentVariant);
              console.log('bold test', p.variants.currentVariant.price); // pass this to my function
               
              setTimeout(() => {
                document.querySelector('.hidden_base_price').textContent = p.variants.currentVariant.price.toString();
              }, 400);
              
              let newURL = url+'?variant='+p.variants.currentVariant.id;
              window.history.pushState(null, null, newURL);
              document.title = title;
              
              $('[name="size"] .variant__button-label.disabled, [name="Size"] .variant__button-label.disabled, [name="SIZE"] .variant__button-label.disabled').each(function(){
                $(this).parents('.variant-input').find('.unavail_option').addClass('disabled')
              });
              if(window.BOLD && BOLD.options && BOLD.common && BOLD.options.app){
                BOLD.options.app.unload();
                BOLD.options.app.boot();
                //trackBoldOptions();
                //resetBasePrice();
              }
            },500);
          
          
        },
        error: function() {
          
            console.error('Error occurred during AJAX request.');
            $el.removeClass('is-loadin');
          
        }
    });
  
});